import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import checkboxIcon from "../../../assets/checkbox.svg";

import {
  CheckboxIcon,
  Facilities,
  FacilitiesHeader,
  FacilitiesText,
  FacilitiesUl,
  SingleFacilities,
} from "./BusFacilities.styles.js";

const BusFacilities = ({ facility }) => {
  const { webSettingData, languageData } = useSelector(
    (state) => state.busLists || {}
  );

  const [facilityList, setFacilityList] = useState([]);
  const [singleFacilityList, setSingleFacilityList] = useState([]);

  useEffect(() => {
    let cancelled = false;

    fetch(`${process.env.REACT_APP_API_MODULE_DOMAIN}/facilities`)
      .then((res) => {
        if (!res.ok) {
          throw new Error("Unable to load facilities");
        }
        return res.json();
      })
      .then((data) => {
        if (!cancelled) {
          setFacilityList(
            Array.isArray(data?.data) ? data.data : []
          );
        }
      })
      .catch((error) => {
        console.error("Unable to load facilities:", error);
        if (!cancelled) setFacilityList([]);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    const facilities = String(facility ?? "")
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean);

    setSingleFacilityList(facilities);
  }, [facility]);

  const facilityName = (id) => {
    const selectedItem = facilityList.find(
      (item) => String(item?.id) === String(id)
    );

    return selectedItem?.name || "";
  };

  const facilitiesTitle =
    languageData?.booking_page_bus_facilities?.[
      webSettingData?.language
    ] || "Facilities";

  return (
    <Facilities>
      <FacilitiesHeader>
        {facilitiesTitle}
      </FacilitiesHeader>

      <FacilitiesUl>
        {singleFacilityList.map((item, index) => {
          const name = facilityName(item);

          if (!name) return null;

          return (
            <SingleFacilities key={item || index}>
              <CheckboxIcon src={checkboxIcon} alt="" />
              <FacilitiesText>{name}</FacilitiesText>
            </SingleFacilities>
          );
        })}
      </FacilitiesUl>
    </Facilities>
  );
};

export default BusFacilities;
